import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@modules/shared.module';
import { ButtonCancelComponent } from '../button-cancel/button-cancel.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
  selector: 'app-button-save',
  standalone: true,
  templateUrl: './button-save.component.html',
  styleUrls: ['./button-save.component.css'],
  imports: [MatIconModule, MatButtonModule, ButtonCancelComponent],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonSaveComponent {
  @Input() disabled!: any
  @Input() isDialogClose: boolean = false
  @Output() saveClicked: EventEmitter<void> = new EventEmitter();
  @Output() cancelClicked: EventEmitter<void> = new EventEmitter();




  constructor() {
    if (this.isDialogClose)
      this.isDialogClose = !this.isDialogClose
  }

  onSaveClick() {
    this.saveClicked.emit();
  }

  onCancelClick() {
    this.cancelClicked.emit();
    if (this.isDialogClose)
      this.isDialogClose = !this.isDialogClose
  }
}
